// extracted by mini-css-extract-plugin
module.exports = {"overallProgressItemContainer":"styles_overallProgressItemContainer__2pfJa","studentProgressBar":"styles_studentProgressBar__218z2"};